export default "__VITE_ASSET__BuIY3fbW__"